$(document).ready(function() {

	//- - - - - - - - - - - - - - - - - - - - - -            init fancybox             - - - - - - - - - - - - - - - - - - - - - -
	$('[data-fancybox]').fancybox();

	//- - - - - - - - - - - - - - - - - - - - - -            init inputmask             - - - - - - - - - - - - - - - - - - - - - -
	$('[type="tel"]').inputmask('+7 (999) 999-99-99');

	//- - - - - - - - - - - - - - - - - - - - - -            init scrollbar             - - - - - - - - - - - - - - - - - - - - - -
  $( '.js-scrollbar' ).mCustomScrollbar();

	//- - - - - - - - - - - - - - - - - - - - - -            init select2             - - - - - - - - - - - - - - - - - - - - - -
  $( '.js-select' ).select2({
    language: 'ru',
    width: '100%',
    minimumResultsForSearch: -1
  });

	/* - - - - - - - - - - - - - -       header fixed       - - - - - - - - - - - - - - - */
	function headerFixed() {
		var top = $(window).scrollTop();
		if ($(window).width() > 991) {
			if (top > $('.header-top').innerHeight()) {
				$('.header').addClass('fixed');
				$('.wrapper').css('padding-top', $('.header-bottom').innerHeight());
			} else {
				$('.header').removeClass('fixed');
				$('.wrapper').css('padding-top', '');
			}
		} else {
			if (top > 0) {
				$('.header').addClass('fixed');
				$('.wrapper').css('padding-top', $('.header').innerHeight());
			} else {
				$('.header').removeClass('fixed')
				$('.wrapper').css('padding-top', '');
			}
		}
	}
	headerFixed();
	$(window).scroll('scroll', function() {
		headerFixed();
	});

	/* - - - - - - - - - - - - - -       menu toggle       - - - - - - - - - - - - - - - */
	$(document).on('click', '.js-menu-toggle, .js-menu-close', function() {
		$('.top-menu').toggleClass('show');
	});

	/* - - - - - - - - - - - - - -       submenu toggle       - - - - - - - - - - - - - - - */
	$(document).on('click', '.submenu-arr', function() {
		$(this).toggleClass('active').closest('li').find('ul').toggle();
	});

	$(window).on('resize', function() {
		if ($(window).width() > 991) {
			$('.header-bottom').removeClass('show');
			$('.top-menu > ul > li ul').css('display', '');
			$('.top-menu').removeClass('show');
			$('.submenu-arr').removeClass('active');
		}
		if ($(window).width() > 767) {
			$('.footer-top__menu-mobile ul li').removeClass('active');
			$('.footer-top__box').removeClass('active');
		}
	});

	$(document).on('click', '.js-search-toggle', function() {
		$('.search-modal').toggleClass('show');
	});

	$(document).on('click', function(event) {
		if ($(event.target).closest('.header-bottom__search').length)
			return;
		$('.search-modal').removeClass('show');
		event.stopPropagation();
	});

	/* - - - - - - - - - - - - - -       footer menu toggle       - - - - - - - - - - - - - - - */
	$(document).on('click', '.footer-top__menu-mobile ul li', function() {
		$('.footer-top__menu-mobile ul li').removeClass('active');
		$(this).toggleClass('active');
		$('.footer-top__box').removeClass('active');
		$('.footer-top__box[data-toggle="' + $(this).attr('data-toggle') + '"]').toggleClass('active');
	});

	function mainCatalogContent() {
		var height = 156,
			$block = $('.main-catalog__content');
		if ($(window).width() <= 767) {
			if ($block.find('.main-catalog__content-text').innerHeight() > height) {
				$block.height(height);
				$('.main-catalog__content-all').show();
			} else {
				$block.height('');
				$('.main-catalog__content-all').hide();
			}
		} else {
			$block.height('');
			$('.main-catalog__content-all').hide();
		}
		$(document).on('click', '.js-main-catalog__content-all', function(e) {
			e.preventDefault();
			$(this).hide();
			$('.main-catalog__content').height('');
		});
	}
	mainCatalogContent();
	$(window).on('resize', function() {
		mainCatalogContent();
	});

	/* - - - - - - - - - - - - - -       count calculate       - - - - - - - - - - - - - - - */
	$('.count-box').each(function() {
		var $this = $(this),
			$field = $this.find('.count'),
			count = 0,
			$plus = $this.find('.count-plus'),
			$minus = $this.find('.count-minus');
		$this.find('.count').on('input', function() {
			return $(this).val($(this).val().replace(/(\D)$/g, ''));
		});
		$plus.on('click', function() {
			$minus.removeClass('disabled');
			count = $field.val();
			if (count < 98) {
				$plus.removeClass('disabled');
				count++;
			} else {
				$plus.addClass('disabled');
				count = 99;
			}
			$field.val(count);
		});
		$minus.on('click', function() {
			$plus.removeClass('disabled');
			count = $field.val();
			if (count > 2) {
				$minus.removeClass('disabled');
				count--;
			} else {
				$minus.addClass('disabled');
				count = 1;
			}
			$field.val(count);
		});
	});

	/* - - - - - - - - - - - - - -       time validation       - - - - - - - - - - - - - - - */
	function timeCount() {
		$('.time-count').each(function() {
			var $timeHour = $(this).find('.time-hour'),
				$timeMinute = $(this).find('.time-minute');
			$timeHour.on('input', function() {
				var countHour = $(this).val();
				if (countHour > 23) {
					countHour = 23;
				} else if (countHour.toString().length > 2) {
					countHour = '00';
				}
				return $(this).val(countHour);
				// return $( this ).val( $( this ).val().replace( /(\D)$/g, '' ) );
			});
			$timeMinute.on('input', function() {
				var countMinute = $(this).val();
				if (countMinute > 59) {
					countMinute = 59;
				} else if (countMinute.toString().length > 2) {
					countMinute = '00';
				}
				return $(this).val(countMinute);
				// return $( this ).val( $( this ).val().replace( /(\D)$/g, '' ) );
			});
		});
	}
	timeCount();

	/* - - - - - - - - - - - - - -       head slider       - - - - - - - - - - - - - - - */
	$('.js-head-slider-arrow').click(function() {
		$('.js-head-slider').slick('slickNext');
	});

	$('.js-head-slider').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: true,
			swipeToSlide: true,
			responsive: [{
				breakpoint: 1200,
				settings: {
					dots: false
				}
			}]
		})
		.on('afterChange', function(slick, currentSlide) {
			var count = currentSlide.slideCount,
				currentNum = currentSlide.currentSlide + 1,
				nextNum = 0;
			if (count == currentNum) {
				nextNum = 1;
			} else {
				nextNum = currentNum + 1;
			}
			currentNum = (currentNum < 10) ? '0' + currentNum : currentNum;
			nextNum = (nextNum < 10) ? '0' + nextNum : nextNum;
			$('.head-slider__box-numprev').text(currentNum);
			$('.head-slider__box-numnext').text(nextNum);
		});

	/* - - - - - - - - - - - - - -       main popular slider       - - - - - - - - - - - - - - - */
	function mainPopulaSlider() {
		var $mainPopularSlider = $('.js-main-popular__slider');
		if ($mainPopularSlider.length > 0) {
			if ($(window).width() <= 767 && !$mainPopularSlider.hasClass('slick-initialized')) {
				$mainPopularSlider.slick({
					infinite: true,
					slidesToShow: 2,
					slidesToScroll: 1,
					arrows: false,
					dots: true,
					swipeToSlide: true,
					responsive: [{
						breakpoint: 575,
						settings: {
							slidesToShow: 1
						}
					}]
				});
				$('.js-main-popular__slider').slick('slickFilter', ':not(.main-popular__catalog)');
			} else if ($(window).width() > 767 && $mainPopularSlider.hasClass('slick-initialized')) {
				$mainPopularSlider.slick('unslick');
			}
		}
	}
	mainPopulaSlider();

	$(window).on('resize', function() {
		mainPopulaSlider();
	});

	/* - - - - - - - - - - - - - -       catalog video slider       - - - - - - - - - - - - - - - */
	$('.js-catalog-video__slider').slick({
		infinite: false,
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		dots: true,
		swipeToSlide: true,
		responsive: [{
			breakpoint: 1580,
			settings: {
				slidesToShow: 3,
			}
		},{
			breakpoint: 992,
			settings: {
				slidesToShow: 2,
			}
		},{
			breakpoint: 576,
			settings: {
				arrows: false,
				slidesToShow: 1,
			}
		}]
	});

	/* - - - - - - - - - - - - - -       product other slider       - - - - - - - - - - - - - - - */
	$('.js-product-other__slider').slick({
		infinite: false,
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		swipeToSlide: true,
		responsive: [{
			breakpoint: 1580,
			settings: {
				slidesToShow: 3,
			}
		},{
			breakpoint: 992,
			settings: {
				slidesToShow: 2,
			}
		},{
			breakpoint: 576,
			settings: {
				arrows: false,
				slidesToShow: 1,
				dots: true
			}
		}]
	});

	/* - - - - - - - - - - - - - -       product other slider       - - - - - - - - - - - - - - - */
	$('.js-product-gallery__small').slick({
		infinite: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		vertical: true,
		verticalSwiping: true,
		swipeToSlide: true,
		focusOnSelect: true,
		asNavFor: '.js-product-gallery__big',
		responsive: [{
			breakpoint: 768,
			settings: {
				slidesToShow: 2,
			}
		}]
	});
	$('.js-product-gallery__big').slick({
		infinite: false,
		slidesToShow: 2,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		swipeToSlide: true,
		asNavFor: '.js-product-gallery__small',
		responsive: [{
			breakpoint: 1580,
			settings: {
				slidesToShow: 1,
			}
		},{
			breakpoint: 992,
			settings: {
				slidesToShow: 2,
			}
		},{
			breakpoint: 576,
			settings: {
				slidesToShow: 1,
			}
		}]
	});

	if ($(window).width() < 767) {
		$('.product-info__list').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: true,
			arrows: false
		});
	}

	if ($(window).width() < 991) {
		$('.delivery-step__list').slick({
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: true,
			arrows: false
		});
	}

	/* - - - - - - - - - - - - - -       init ionRangeSlider       - - - - - - - - - - - - - - - */
  var sliderRanse = $( '.js-range' ).each(function() {
    var $range = $( this ),
      $parent = $range.closest( '.range-box' ),
      $inputFrom = $parent.find( '.range-box__value-from' ),
      $inputTo = $parent.find( '.range-box__value-to' ),
      min = $range.attr( 'data-min' ),
      max = $range.attr( 'data-max' ),
      valueFrom = $range.attr( 'data-from' ),
      valueTo = $range.attr( 'data-to' ),
      instance;
    $range.ionRangeSlider({
      type: "double",
      grid: false,
      // min: min,
      // max: max,
      // from: valueFrom,
      // to: valueTo,
      onStart: updateInputs,
      onChange: updateInputs,
      hide_from_to: true
    });
    instance = $range.data( 'ionRangeSlider' );
    function updateInputs (data) {
      from = data.from;
      to = data.to;
      $inputFrom.prop( 'value', from );
      $inputTo.prop( 'value', to );
    }
    $inputFrom.on( 'input', function () {
      var val = parseInt( $( this ).prop( 'value' ) ),
        to = parseInt( $( this ).closest( '.range-box' ).find( '.range-box__value-to' ).prop( 'value' ) );
      // validate
      if ( val < min ) {
        val = min;
      } else if ( val > to ) {
        val = to;
      }
      instance.update({
        from: val
      });
    });
    $inputTo.on( 'input', function () {
      var val = parseInt( $( this ).prop( 'value' ) ),
      from = parseInt( $( this ).closest( '.range-box' ).find( '.range-box__value-from' ).prop( 'value' ) );
      // validate
      if ( val < from ) {
        val = from;
      } else if ( val > max ) {
        val = max;
      }
      instance.update({
        to: val
      });
    });
    function prettify(num) {
      var n = num.toString();
      return n.replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, '$1' + ' ');
    }
  });

	//- - - - - - - - - - - - - - - - - - - - - -            filter box toggle             - - - - - - - - - - - - - - - - - - - - - -
	$( document ).on( 'click', '.js-filter-toggle', function() {
		var $this = $( this ),
			$parent = $this.closest( '.filter' );
		$parent.toggleClass( 'active' );
		if ( $parent.hasClass( 'active' ) ) {
			$this.text( $this.attr( 'data-text-hide' ) );
		} else {
			$this.text( $this.attr( 'data-text-show' ) );
		}

		$('.catalog-item__list').toggleClass('full_width');
		$('.pagination').toggleClass('full_width');
	});
	$( document ).on( 'click', '.js-filter-box-toggle', function() {
    var $parent = $( this ).closest( '.filter-list__box' );
    $parent.toggleClass( 'active' );
  });

	$(document).on('click', '.product-button .btn', function(e) {
		e.preventDefault();
		$('html,body').animate({scrollTop: $('#product-form').offset().top - 60},800);
	})

	//- - - - - - - - - - - - - - - - - - - - - -            footer fixed             - - - - - - - - - - - - - - - - - - - - - -
	function footerFixed() {
    var height = $( '.footer' ).innerHeight();
    $( '.wrapper' ).css( 'padding-bottom', height );
    height = '-' + height + 'px';
    $( '.footer' ).css( 'margin-top', height );
	}
	footerFixed();
	$( window ).resize( function() {
		footerFixed();
	});
	$( window ).scroll( function() {
		footerFixed();
	});

	// setTimeout(function() {
	// 	$('#modal-subscribe').modal('show');
	// }, 15000);

	$('.js-tabs > *').on('click', function() {
		$(this).addClass('active');
		$(this).siblings().removeClass('active');
		$(this).parent().next().children().eq($(this).index()).addClass('active');
		$(this).parent().next().children().eq($(this).index()).siblings().removeClass('active');
	});

});
